define(["require", "exports", "tslib", "mobx", "../../store/UserStore", "../domain"], function (require, exports, tslib_1, mobx_1, UserStore_1, domain_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaApproval = void 0;
    class WaApproval {
        constructor(wa) {
            Object.defineProperty(this, "wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusPreWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsApproveEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApproveDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "CanUserCaptureApprovalComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsRefuseEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefuseDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsCancelEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CancelDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsReverseCancellationEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ReverseCancellationDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            (0, mobx_1.makeObservable)(this);
            this.wa = wa;
            this.evaluateStatus();
            this.statusWatcher = (0, mobx_1.observe)(this.wa, "ApprovalStatus", x => {
                this.evaluateStatus();
            });
            this.statusPreWatcher = (0, mobx_1.observe)(this.wa, "ApprovalStatusPrev", x => {
                this.evaluateStatus();
            });
        }
        evaluateStatus() {
            this.deriveApproveState();
            this.deriveCancelState();
            this.deriveRefuseState();
            this.deriveReverseCancelState();
        }
        get ActiveStatus() {
            if (this.wa.ApprovalStatusReq) {
                return this.wa.ApprovalStatusReq;
            }
            else {
                return this.wa.ApprovalStatus;
            }
        }
        get IsPendingApprovalOrFinalised() {
            return this.ActiveStatus == domain_1.WaStatusDomain.PendingApprovalLga || this.ActiveStatus == domain_1.WaStatusDomain.Finalised;
        }
        approve() {
            switch (this.wa.ApprovalStatus) {
                case domain_1.WaStatusDomain.Draft:
                    this.setStatus(domain_1.WaStatusDomain.Finalised);
                    break;
                case domain_1.WaStatusDomain.PendingApprovalLga:
                    this.setStatus(domain_1.WaStatusDomain.Finalised);
                    break;
                case domain_1.WaStatusDomain.Finalised:
                    throw new Error("Can not promote a Water Agreement that is in an Finalised state");
                case domain_1.WaStatusDomain.Terminated:
                    throw new Error("Can not promote a Water Agreement that is in a Terminated state");
                case domain_1.WaStatusDomain.Refused:
                    throw new Error("Can not promote a Water Agreement that is in a Refused state");
                default:
                    throw new Error("Unknown Water Agreement Status");
            }
            this.evaluateStatus();
        }
        refuse() {
            if (this.wa.ApprovalStatus == domain_1.WaStatusDomain.Draft || this.wa.ApprovalStatus == domain_1.WaStatusDomain.PendingApprovalLga) {
                this.setStatus(domain_1.WaStatusDomain.Refused);
            }
            else if (this.wa.ApprovalStatus == domain_1.WaStatusDomain.Terminated) {
                this.setStatus(domain_1.WaStatusDomain.Refused);
            }
            else {
                throw new Error(`A Water Agreement with a status of ${this.wa.ApprovalStatus} can not be refused.`);
            }
            this.evaluateStatus();
        }
        cancel() {
            if (this.wa.ApprovalStatus == domain_1.WaStatusDomain.Draft || this.wa.ApprovalStatus == domain_1.WaStatusDomain.PendingApprovalLga || this.wa.ApprovalStatus == domain_1.WaStatusDomain.Finalised) {
                this.setStatus(domain_1.WaStatusDomain.Terminated);
            }
            else {
                throw new Error(`A Water Agreement with a status of ${this.wa.ApprovalStatus} can not be cancelled.`);
            }
            this.evaluateStatus();
        }
        reverseCancellation() {
            if (this.wa.ApprovalStatus == domain_1.WaStatusDomain.Terminated && this.wa.ApprovalStatusPrev == domain_1.WaStatusDomain.Finalised) {
                this.setStatus(domain_1.WaStatusDomain.Finalised);
            }
            else {
                throw new Error(`A Water Agreement with a status of ${this.wa.ApprovalStatus} can not be Reverse Terminated."`);
            }
            this.evaluateStatus();
        }
        deriveApproveState() {
            this.ApproveDesc = "Approve";
            if (this.wa && this.wa.IsUserPriviledgedToEdit) {
                switch (this.wa.ApprovalStatus) {
                    case domain_1.WaStatusDomain.Draft:
                        this.ApproveDesc = "Request Approval";
                        this.IsApproveEnabled = true;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.WaStatusDomain.PendingApprovalLga:
                        this.ApproveDesc = "Approve";
                        this.CanUserCaptureApprovalComment = true;
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsApproveEnabled = true;
                        }
                        else {
                            this.IsApproveEnabled = false;
                        }
                        break;
                    case domain_1.WaStatusDomain.Finalised:
                        this.ApproveDesc = "Finalised";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.WaStatusDomain.Terminated:
                        this.ApproveDesc = "Terminated";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.WaStatusDomain.Refused:
                        this.ApproveDesc = "Refused";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    default:
                        throw new Error("Unknown WA Status");
                }
            }
            else {
                this.IsApproveEnabled = false;
                this.CanUserCaptureApprovalComment = false;
            }
        }
        deriveRefuseState() {
            this.RefuseDesc = "Refuse";
            if (this.wa && this.wa.IsUserPriviledgedToEdit) {
                switch (this.wa.ApprovalStatus) {
                    case domain_1.WaStatusDomain.Draft:
                        this.IsRefuseEnabled = false;
                        break;
                    case domain_1.WaStatusDomain.PendingApprovalLga:
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsRefuseEnabled = true;
                        }
                        else {
                            this.IsRefuseEnabled = false;
                        }
                        break;
                    default:
                        this.IsRefuseEnabled = false;
                }
            }
            else {
                this.IsRefuseEnabled = false;
            }
        }
        deriveCancelState() {
            this.CancelDesc = "Cancel";
            if (this.wa && this.wa.IsUserPriviledgedToEdit) {
                switch (this.wa.ApprovalStatus) {
                    case domain_1.WaStatusDomain.Draft:
                        this.IsCancelEnabled = true;
                        break;
                    case domain_1.WaStatusDomain.PendingApprovalLga:
                        this.IsCancelEnabled = true;
                        break;
                    case domain_1.WaStatusDomain.Finalised:
                        this.IsCancelEnabled = true;
                        break;
                    default:
                        this.IsCancelEnabled = false;
                }
            }
            else {
                this.IsCancelEnabled = false;
            }
        }
        deriveReverseCancelState() {
            this.ReverseCancellationDesc = "Reverse Cancellation";
            if (this.wa && this.wa.IsUserPriviledgedToEdit && this.wa.SystemState != domain_1.EntitySysStatusDomain.Archived) {
                switch (this.wa.ApprovalStatus) {
                    case domain_1.WaStatusDomain.Terminated:
                        if (this.wa.ApprovalStatusPrev == domain_1.WaStatusDomain.Finalised) {
                            this.IsReverseCancellationEnabled = true;
                        }
                        else {
                            this.IsReverseCancellationEnabled = false;
                        }
                        break;
                    default:
                        this.IsReverseCancellationEnabled = false;
                }
            }
            else {
                this.IsReverseCancellationEnabled = false;
            }
        }
        restoreToOriginalStatus() {
            this.wa.ApprovalStatusReq = null;
            this.evaluateStatus();
        }
        setStatus(status) {
            this.wa.ApprovalStatusReq = status;
        }
    }
    exports.WaApproval = WaApproval;
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "IsApproveEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "ApproveDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "CanUserCaptureApprovalComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "IsRefuseEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "RefuseDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "IsCancelEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "CancelDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "IsReverseCancellationEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaApproval.prototype, "ReverseCancellationDesc", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], WaApproval.prototype, "ActiveStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "approve", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "refuse", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "cancel", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "reverseCancellation", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "deriveApproveState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "deriveRefuseState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "deriveCancelState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "deriveReverseCancelState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "restoreToOriginalStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaApproval.prototype, "setStatus", null);
});
